import { API_BASE_URL } from '../../config/apiBase';
import { equipmentState } from './state';
import { parseXMLData } from './parser';

/**
 * Загружает данные оборудования из XML через proxy сервер.
 * @param {string} url 
 * @returns {Promise<Array>} 
 */
export async function loadEquipmentFromProxy(url = `${API_BASE_URL}/yml`) {
    const cached = equipmentState.getData();
    if (cached) return cached;

    const existingPromise = equipmentState.getPromise();
    if (existingPromise) return existingPromise;

    equipmentState.setLoading(true);

    const safeUrl = `${url}${url.includes('?') ? '&' : '?'}t=${Date.now() + 3}`;

    const promise = fetch(safeUrl)
        .then(response => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
        })
        .then(xmlText => {
            if (xmlText.trim().startsWith('<html') || xmlText.trim().startsWith('<!DOCTYPE')) {
                throw new Error('Получена HTML страница вместо XML данных');
            }
            return parseXMLData(xmlText);
        })
        .then(data => {
            equipmentState.setData(data);
            equipmentState.setLoading(false);
            equipmentState.setPromise(null);
            return data;
        })
        .catch(error => {
            console.warn('Proxy load failed, falling back to local file:', error);
            return fetch('/equipment.xml')
                .then(res => {
                    if (!res.ok) throw new Error(`Local file error! status: ${res.status}`);
                    return res.text();
                })
                .then((xmlText) => {
                    const t = xmlText.trim();
                    if (t.startsWith('<html') || t.startsWith('<!DOCTYPE')) {
                        throw new Error(
                            'Ответ по /equipment.xml — HTML (часто SPA), а не XML. Исправьте сервер /yml или раздачу статики.'
                        );
                    }
                    return parseXMLData(xmlText);
                })
                .then(data => {
                    equipmentState.setData(data);
                    equipmentState.setLoading(false);
                    equipmentState.setPromise(null);
                    return data;
                })
                .catch(localError => {
                    equipmentState.setLoading(false);
                    equipmentState.setPromise(null);
                    throw new Error('Не удалось загрузить данные (Proxy + Local failed)');
                });
        });

    equipmentState.setPromise(promise);
    return promise;
}

/**
 * Получить статус загрузки
 */
export function getLoadingStatus() {
    const data = equipmentState.getData();
    return {
        isLoading: equipmentState.getLoading(),
        isLoaded: !!data,
        itemCount: data?.length || 0
    };
}

/**
 * Проверить, загружены ли данные
 */
export function isDataLoaded() {
    return !!equipmentState.getData();
}

/**
 * Очистить кэш
 */
export function clearEquipmentCache() {
    equipmentState.clear();
}
